import Cookies from 'js-cookie'

const TokenKey = 'welab_web'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token,{expires:7})
}
export function setHeartBeatToken(token){
  return Cookies.set('xiyilab_hb', token,{expires:7})
}
export function getHeartBeatToken(token){
  return Cookies.get('xiyilab_hb')
}
export function removeHeartBeatToken() {
  return Cookies.remove('xiyilab_hb')
}
export function setShanxiToken(token) {
  return Cookies.set('shanxi_xiyilab', token,{expires:7})
}
export function getShanxiToken() {
  return Cookies.get('shanxi_xiyilab')
}
export function removeShanxiToken() {
  return Cookies.remove('shanxi_xiyilab')
}
export function removeToken() {
  return Cookies.remove(TokenKey)
}
